import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(public)/documents/page.tsx");
